import { floorToN } from '@/components/features/casino/crash/GameBox/utils';

/**
 *
 * @param x crashTime
 */
export function getY(x: number) {
  return Math.pow(2, x * 0.09);
}

export function getMultiplier(multiplier: number, needX = true) {
  const suffix = needX ? ' x' : '';
  try {
    return floorToN(Number(multiplier)).toFixed(2) + suffix;
  } catch (e) {
    console.log(e);
    return '1.00x';
  }
}
